exports = module.exports = require("../../../../../../../shared/rnclient/node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "\n.reported-date-picker--label--2WC9FhDd {\n  font-size: 105%;\n  font-weight: bold;\n}\n\n.reported-date-picker--header--DvB9l1KA {\n  display: none;\n}\n", "", {"version":3,"sources":["/./src/web/components/themes/reported-date-picker.css"],"names":[],"mappings":";AACA;EACE,gBAAgB;EAChB,kBAAkB;CACnB;;AAED;EACE,cAAc;CACf","file":"reported-date-picker.css","sourcesContent":["\n.label {\n  font-size: 105%;\n  font-weight: bold;\n}\n\n.header {\n  display: none;\n}\n"],"sourceRoot":"webpack://"}]);

// exports
exports.locals = {
	"label": "reported-date-picker--label--2WC9FhDd",
	"header": "reported-date-picker--header--DvB9l1KA"
};


//////////////////
// WEBPACK FOOTER
// /home/deploy/gamba/shared/rnclient/node_modules/css-loader?{"modules":true,"sourceMap":true,"importLoaders":1,"localIdentName":"[name]--[local]--[hash:base64:8]"}!/home/deploy/gamba/shared/rnclient/node_modules/postcss-loader/lib!./src/web/components/themes/reported-date-picker.css
// module id = 2357
// module chunks = 4